export default {
  RX_STATES: 'rxAvailableStates',
}